interface DatePickerProps {
  label?: string;
  onChange?: (date: Date) => void; // Make sure this matches the usage;
}

const DatePicker: React.FC<DatePickerProps> = ({ label, onChange }) => {
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(new Date(event.target.value)); // Pass the selected date
    }
  };

  return (
    <div>
      <label>{label}</label>
      <input type="date" onChange={handleDateChange} />
    </div>
  );
};

export default DatePicker;
